module.exports = __webpack_public_path__ + "img/two.995680f5.png";